import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material"
import { OrganizationReportDialog } from "components/Report/OrganizationReportDialog"
import { OrganizationUsersReportDialog } from "components/Report/OrganizationUsersReportDialog"
import { useRef, useState } from "react"

export function ReportListButton() {
  const [reportMenuOpen, setReportMenuOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const handleToggle = () => {
    setReportMenuOpen((prevOpen) => !prevOpen)
  }

  const handleClose = () => {
    setReportMenuOpen(false)
  }

  const [organizationReportDialogOpen, setOrganizationReportDialogOpen] = useState(false)

  const handleOrganizationReportDialogOpen = (open: boolean) => {
    setOrganizationReportDialogOpen(open)
  }

  const [organizationUsersReportDialogOpen, setOrganizationUsersReportDialogOpen] = useState(false)

  const handleOrganizationUsersReportDialogOpen = (open: boolean) => {
    setOrganizationUsersReportDialogOpen(open)
  }

  return (
    <div>
      <Button
        ref={anchorRef}
        aria-controls={reportMenuOpen ? "composition-menu" : undefined}
        aria-expanded={reportMenuOpen ? "true" : undefined}
        aria-haspopup="true"
        variant="outlined"
        onClick={handleToggle}
      >
        GENERATE REPORTS
      </Button>
      <Popper
        open={reportMenuOpen}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={reportMenuOpen}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                >
                  <MenuItem
                    onClick={() => {
                      handleOrganizationReportDialogOpen(true)
                    }}
                  >
                    Organization report
                  </MenuItem>
                  <OrganizationReportDialog
                    open={organizationReportDialogOpen}
                    handleClose={() => handleOrganizationReportDialogOpen(false)}
                  />
                  <MenuItem
                    onClick={() => {
                      handleOrganizationUsersReportDialogOpen(true)
                    }}
                  >
                    Users report
                  </MenuItem>
                  <OrganizationUsersReportDialog
                    open={organizationUsersReportDialogOpen}
                    handleClose={() => handleOrganizationUsersReportDialogOpen(false)}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
